import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.ListItemFilters, {
        attrs: {
          icon: "ui-icon-map-pin",
          title:
            _setup.doctorFiltersState.city?.name ||
            _setup.t("Город врача", _setup.options),
          subtitle: _setup.doctorFiltersState.city
            ? _setup.t("Город врача", _setup.options)
            : "",
        },
        on: { click: _setup.openDialog },
      }),
      _vm._v(" "),
      _c(_setup.CityModal, {
        attrs: {
          value: _setup.isDialogOpened,
          "is-back": "",
          "selected-city": _setup.filtersStore.unsavedFilters.city,
        },
        on: {
          "city:selected": _setup.onClickCity,
          "city:reset": _setup.onResetCity,
          input: _setup.handleCloseCityModal,
        },
        scopedSlots: _vm._u([
          {
            key: "footer",
            fn: function ({ selectedCity }) {
              return [
                _c(
                  "div",
                  { staticClass: "pa-2 elevation-8" },
                  [
                    _c(
                      VBtn,
                      {
                        attrs: {
                          block: "",
                          depressed: "",
                          color: "primary",
                          disabled: !_setup.hasUnsavedCity,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.handleCitySelected(selectedCity)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t("Применить", _setup.options)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }